






































































































































































































import BaseComponent from '@/components/base-component.vue';
import NotificationForm from '@/components/notifications/notification-form.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocompleTeams from '@/components/UI/autocomplete-team.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { NotificacaoFiltroDTO, NOTIF_TARGET_CLIENT_UNITS, NOTIF_TARGET_LIST, NOTIF_TARGET_PROFILES, NOTIF_TARGET_TEAMS, NOTIF_TARGET_USERS, NOTIF_TIPO_GENERICO } from '@/interfaces/notification';
import * as service from '@/services/notification';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { PaginationSyncDTO, ResultPagDTO } from '../../../interfaces/base-dto';


@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    NotificationForm,
    UiDatePicker,
    UiAutocompleClientsSubsidiaries,
    UiAutocompleTeams
  }
})
export default class Notifications extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public oldtitulo = null;

  public id: Number = null;
  profiles = [];
  businessUnits = [];
  types = [];
  logins = [];
  loadingLogins = false;
  loginsInclusao = [];
  loadingLoginsInclusao = false;
  private filtros: NotificacaoFiltroDTO = new NotificacaoFiltroDTO();
  private items: any[] = [];

  targets:any[] = NOTIF_TARGET_LIST;

  TARGET_USERS = NOTIF_TARGET_USERS;
  TARGET_PROFILES = NOTIF_TARGET_PROFILES;
  TARGET_CLIENT_UNITS = NOTIF_TARGET_CLIENT_UNITS;
  TARGET_TEAMS = NOTIF_TARGET_TEAMS; 

  public headers: any = [
    { text: 'Titulo', value: 'titulo', sortable: true },
    { text: 'Tipo', value: 'tipo', sortable: true },
    { text: 'Alvo', value: 'alvo', sortable: true },
    { text: 'Período publicado', value: 'inicioPublicacao', sortable: true },
    { text: 'Atualizado por', value: 'loginAlteracao', sortable: true },
    { text: 'Atualizado em', value: 'dataAlteracao', sortable: true },
    { text: 'Leituras (Usuários)', value: 'qtdeUsuarioLeitura', sortable: false, align: "center" },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false }
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public pagina: ResultPagDTO<any> = new ResultPagDTO();

  private beforeMount(): void {
    this.loadProfiles();
    this.loadBusinessUnits();
    this.loadTypes();
    this.loadLogins();
    this.loadLoginsInclusao();
    this.filtros.tipo = NOTIF_TIPO_GENERICO;
    this.filtros.ativo = true;
  }

  mounted() {
    this.onChangeSearch();
  }

  private loadProfiles(): void {
    service.findNotificationProfiles().subscribe((data) => {
      this.profiles = data;
    });
  }

  public loadBusinessUnits() {
    service.findNotificationBusinessUnit().subscribe(
      (res) => {
        this.businessUnits = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  public loadTypes() {
    service.findNotificationTypes().subscribe(
      (res) => {
        this.types = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  public loadLogins() {
    this.loadingLogins = true;
    service.findNotificationLoginsNotified().subscribe(
      (res) => {
        this.logins = res;
        this.loadingLogins = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loadingLogins = false;
      }
    );
  }

  public loadLoginsInclusao() {
    this.loadingLoginsInclusao = true;
    service.findNotificationLoginsCreator().subscribe(
      (res) => {
        this.loginsInclusao = res;
        this.loadingLoginsInclusao = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loadingLoginsInclusao = false;
      }
    );
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.oldtitulo = this.filtros.titulo;
    this.pesquisar();
  }

  private pesquisar() {
    this.loading = true;
    this.error = false;
    this.filtros.update(this.pagination);
    if (this.filtros.idLogin && !this.logins.find(l => l.id == this.filtros.idLogin)) {
      this.filtros.idLogin = null;
    }
    this.addSubsc(
      service.findNotificationsByFilters(this.filtros).subscribe(
        (result) => {
          this.loading = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        }
      )
    );
  }

  private newItem(): void {
    this.id = null;
    this.formIsEdit = true;
    this.formOpen = true;
  }

  private onEditItem(item): void {
    this.id = item.id;
    this.formIsEdit = true;
    this.formOpen = true;
  }

  private onViewItem(item): void {
    this.id = item.id;
    this.formIsEdit = false;
    this.formOpen = true;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  private saveItem(): void {
    this.closeForm();    
    this.loadLogins();
    this.loadLoginsInclusao();
    this.onChangeSearch();
  }

  @Watch('filtros.alvo')
  private onAlvoChange() {
    this.filtros.idEmpresa = null;
    this.filtros.idLogin = null;
    this.filtros.idPerfil = null;
    this.filtros.idUnidade = null;
    this.filtros.idTime = null;
  }
}
